const r = {
  id: "OhioKeno",
  logo: !0,
  name: "Keno",
  style: {
    colorAccent: "#b5141f",
    colorPrimary: "#b5141f",
    highFrequency: {
      backButtonColor: "var(--color-text-primary-primary)",
      ball: {
        background: "radial-gradient(50% 50% at 50% 50%, #d83b2b 0%, #b5141f 100%)",
        highlight: "0 0 1.75rem 0 #b5141f",
        selected: {
          background: "#b5141f",
          borderColor: "#b5141f",
          textColor: "var(--color-text-primary-primary-inverted)"
        },
        shadow: "linear-gradient(90deg, rgb(0, 0, 0, 0%) 0%, rgb(0, 0, 0, 40%) 50%, rgb(0, 0, 0, 0%) 100%)",
        textColor: "var(--color-text-primary-primary-inverted)"
      },
      bonus: {
        gameCardText: "#b5141f",
        headline: "#2e368e",
        multiplier: "#a72c24"
      },
      colorPrimaryAccent: "#b5141f",
      nextDraw: {
        background: "radial-gradient(124.84% 92% at 49.13% 23.21%, rgba(255, 215, 110, 0.00) 0%, rgba(248, 215, 5, 0.80) 100%)",
        backgroundColor: "#f1b01d",
        cardBorderColor: "transparent",
        notOperating: {
          cardBackground: "linear-gradient(270deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 247, 181, 0.90) 100%)",
          numberColor: "var(--color-text-secondary-secondary)"
        },
        pending: {
          cardBackground: "linear-gradient(105deg, rgba(255, 255, 255, 0.80) 9.66%, rgba(255, 255, 255, 0.40) 101.61%)",
          numberColor: "var(--color-text-primary-primary)",
          progressbarColor: "linear-gradient(270deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 247, 181, 0.90) 100%)"
        },
        ready: {
          cardBackground: "linear-gradient(270deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 247, 181, 0.90) 100%)",
          numberColor: "#B5141F"
        },
        textColor: "var(--color-text-primary-primary)"
      },
      order: {
        background: "linear-gradient(180deg, #ffba2c 24rem, #fae000 35rem, rgb(250 224 0 / 0.07))",
        backgroundColor: "#060871",
        topSection: {
          gradient: "radial-gradient(45.73% 50% at 50% 42.67%, #ffed03 0%, rgb(255 237 3 / 0.60) 46.15%, rgb(255 186 44 / 0.95) 100%)",
          textColor: {
            primary: "var(--color-text-primary-primary)",
            secondary: "#595e99"
          }
        }
      },
      results: {
        backgroundColor: "#FFBA2C",
        bottomGradient: "linear-gradient(270deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 247, 181, 0.90) 100%)",
        bottomText: "var(--color-text-primary-primary)"
      },
      teaser: {
        backgroundColor: "#ffee75",
        backgroundGradient: "radial-gradient(50% 62.76% at 50% 52.02%, rgba(255, 186, 44, 0.00) 0%, rgba(255, 186, 44, 0.60) 60.1%, #FFBA2C 100%)",
        jackpotColor: "#2e368e",
        logoColor: "#2e368e",
        textColor: "var(--color-text-primary-primary)",
        watch: {
          backgroundGradient: "linear-gradient(180deg, #FFED02 45.24%, #FFBA2C 99.65%)",
          badge: {
            background: "#FFF6A8",
            borderColor: "#FFF6A8",
            gameColor: "#AE3026",
            textColor: "#2E368E"
          },
          footerColor: "#000860",
          gameBackgroundGradient: "radial-gradient(47.98% 49.26% at 50% 55.93%, rgba(255, 237, 2, 0) 0%, rgba(255, 212, 23, 0.5) 50%, #ffba2c 100%)",
          icon: {
            arrowsColor: "#252525",
            arrowsColorFade: "#FFBA2C",
            pauseColor: "#000860",
            timerColor: "#252525"
          },
          newGameColor: "#AE3026",
          play: {
            colorEnd: "#2E368E",
            colorStart: "#4D5184",
            dropShadowColor: "rgba(174, 48, 38, 0.27)",
            shadowColor: "#2E368E"
          },
          titleColor: "#2E368E"
        }
      },
      watchMode: {
        background: "linear-gradient(180deg, #fae000 0%, #ffba2c 34.62%)",
        badge: {
          background: "#FFF6A8",
          borderColor: "#FFF6A8",
          gameColor: "#a72c24",
          textColor: "#2e368e"
        },
        bonusColor: "#49c2d3",
        bonusEffectColor: "#a72c24",
        main: {
          background: "radial-gradient(57.77% 77.4% at 50% 46.16%, #FFED02 0%, #FFBA2C 100%)",
          card: {
            background: "#fae000",
            borderColor: "#fae000"
          }
        },
        textColor: "var(--color-text-primary-primary)"
      }
    }
  }
};
export {
  r as default
};
